<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-01-14 09:52:53
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-22 13:56:58
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="left-side">
        <el-tree
          ref="tree"
          :props="treeProps"
          :load="loadNode"
          lazy
          node-key="id"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
      <div class="right-side">
        <div class="top-info">
          <h3 class="title">
            {{ curTwoLevelVillGroup.groupName }}
            <span v-show="threeLevelVillGroup.length > 0">{{
              `(${threeLevelVillGroup.length}人)`
            }}</span>
          </h3>
        </div>
        <el-table
          ref="multipleTable"
          :data="threeLevelVillGroup"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="personName"
            label="姓名"
            min-width="10%"
            align="center"
          >
          </el-table-column>
          <el-table-column label="性别" min-width="6%" align="center">
            <template slot-scope="scope">
              {{ scope.row.sex | formatSex }}
            </template>
          </el-table-column>
          <el-table-column
            prop="personAge"
            label="年龄"
            min-width="6%"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            min-width="10%"
            align="center"
          >
          </el-table-column>
          <el-table-column label="户主" min-width="6%" align="center">
            <template slot-scope="scope">
              {{ scope.row.isHolder | formatIsHolder }}
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            min-width="10%"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="handleLookDetail(scope.row)"
                >查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total,prev, pager, next,jumper"
          :page-size="this.pagination.pageSize"
          :total="pagination.recordTotal"
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
export default {
  name: "HumanResources",
  data() {
    return {
      oneLevelVillGroup: [],
      twoLevelVillGroup: [],
      threeLevelVillGroup: [],
      curOneLevelVillGroup: "", // 一级目录
      curTwoLevelVillGroup: "", // 二级目录
      multipleSelection: [],
      dialogVisible: false,
      groupName: "", // 村民小组名称
      dialog: {
        show: false,
        type: "",
      },
      treeProps: {
        label: "groupName",
        isLeaf: "leaf",
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      masterId: "",
    };
  },
  filters: {
    formatSex(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "男";
          break;
        case 0:
          result = "女";
          break;
      }
      return result;
    },
    formatIsHolder(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "是";
          break;
        case 0:
          result = "否";
          break;
      }
      return result;
    },
  },
  mounted() {},
  methods: {
    /**
     * @descripttion: 加载左侧树形菜单
     * @Author: juanjuanhui
     * @Date: 2022-01-15 11:02:43
     * @param {*} node
     * @param {*} resolve
     */
    async loadNode(node, resolve) {
      let res1 = await this.getOneLevelVillGroup();
      if (node.level === 0) {
        this.oneLevelVillGroup = res1.data;
        res1.data.forEach((item) => {
          item.disabled = true;
        });
        this.defaultExpandedKeys = [res1.data[0].id];
        this.curOneLevelVillGroup = res1.data[0];
        return resolve(res1.data);
      }
      if (node.level > 1) {
        return resolve([]);
      }
      let res2 = await this.getTwoLevelVillGroup({ id: node.data.id });
      res2.data.forEach((item) => {
        item.leaf = true;
      });
      this.twoLevelVillGroup = res2.data;
      this.defaultCheckedKeys = [res2.data[0].id];
      this.curTwoLevelVillGroup = res2.data[0];
      this.getThreeLevelVillGroup({ id: this.curTwoLevelVillGroup.id });
      resolve(res2.data);
    },
    /**
     * @descripttion: 点击树形菜单节点
     * @Author: juanjuanhui
     * @Date: 2022-01-15 11:03:10
     * @param {*} data
     */
    handleNodeClick(data) {
      if (data.organizeLevel != 1) {
        this.curTwoLevelVillGroup = data;
        this.$refs.tree.setCheckedKeys([data.id]);
        this.getThreeLevelVillGroup({ id: data.id });
      }
    },
    /**
     * @descripttion: 获取组织管理一级目录
     * @Author: juanjuanhui
     * @Date: 2022-01-05 20:04:55
     */
    getOneLevelVillGroup() {
      return this.$http.village.oneLevelVillGroup({ masterId: this.masterId });
    },
    /**
     * @descripttion: 获取组织管理二级目录
     * @Author: juanjuanhui
     * @Date: 2022-01-05 20:04:55
     */
    getTwoLevelVillGroup(params) {
      params.masterId = this.masterId;
      return this.$http.village.twoLevelVillGroup(params);
    },
    /**
     * @descripttion: 获取组织管理三级目录
     * @Author: juanjuanhui
     * @Date: 2022-01-05 20:04:55
     */
    getThreeLevelVillGroup(params) {
      let { currentPage, pageSize } = this.pagination;
      params = { ...params, currentPage, pageSize };
      this.$http.village.threeLevelVillGroup(params).then((res) => {
        let { recordTotal, content: threeLevelVillGroup } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.threeLevelVillGroup = threeLevelVillGroup;
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getThreeLevelVillGroup({ id: this.curTwoLevelVillGroup[0].id });
    },
    /**
     * @descripttion: 选中或取消选中
     * @Author: juanjuanhui
     * @Date: 2022-01-12 09:55:57
     * @param {*} rows
     * @return {*}
     */
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    /**
     * @descripttion: 获取选中的值
     * @Author: juanjuanhui
     * @Date: 2022-01-12 09:56:23
     * @param {*} val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2022-01-15 20:51:27
     * @param {*} item
     */
    handleLookDetail(item, type) {
      this.$router.push({
        path: "/village/resources-query/human-detail",
        query: {
          id: item.id,
          from_type: type,
        },
      });
    },
  },
  created() {
    this.masterId = this.$route.query.$businessAccountId;
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.main {
  display: flex;
  padding: 0 !important;
  max-height: calc(100% - 56px);
  .left-side {
    padding: 16px;
    width: 200px;
    overflow: hidden;
    border-right: 1px solid #efefef;
    overflow-y: auto;
    ::v-deep {
      .el-tree {
        .el-tree-node {
          &.is-focusable {
            .el-tree-node__content {
              background-color: #fff;
            }
          }
          &.is-checked {
            .el-tree-node__content {
              background-color: #e1f4f5;
            }
          }
          .el-tree-node__content {
            height: 40px;
            &:hover {
              background-color: #e1f4f5;
            }
            .el-tree-node__label {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  .right-side {
    flex: 1;
    padding: 16px;
    .top-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 20px;
        color: #018388;
      }
    }
    .el-table {
      margin-top: 16px;
    }
    .btn-foot {
      display: flex;
      align-items: center;
      margin-top: 12px;
      .tip {
        margin-left: 10px;
        color: #df0000;
      }
    }
  }
}
::v-deep {
  .el-dialog {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      .info {
        width: 300px;
        margin: 0 auto;
        .title {
          text-align: center;
          font-size: 22px;
          color: #444444;
        }
        .el-input {
          margin-top: 20px;
          .el-input__inner {
            text-align: center;
          }
        }
      }
    }
    .el-dialog__footer {
      padding-top: 0;
      padding-bottom: 30px;
      text-align: center;
    }
  }
  .dialog-del {
    .el-dialog__body {
      .info {
        margin-top: 20px;
        .txt {
          padding-top: 5px;
          font-size: 18px;
          text-align: center;
          color: #a3a3a3;
        }
      }
    }
  }
}
</style>
